import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RecyclingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"recycling"}/>
}
